<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog :close-on-click-modal="false" title="添加付款" :show-close="true" :visible="true"
    :before-close="handleBeforeClose" width="725px">
    <div class="dialog__container">
      <el-form class="search-form" label-position="right" label-width="100px" :ref="'formRef'" :model="formSelect"
        :rules="rulesSelect">
        <el-form-item label="支出项:" prop="spendingList" class="input-with-col2 mr0">
          <el-select size="mini" multiple collapse-tags v-model="formSelect.spendingList" filterable placeholder="请选择支出项"
            clearable @change="selectSpendingChange" value-key="code">
            <el-option v-for="item in spendingList" :key="item.code" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="tag_box">
        <el-tag v-for="(tag, index) in tags" :key="tag.name" :type="showTagIndex == index ? '' : tag.type"
          style="margin:5px 5px;cursor: pointer;" @click="showTagIndex = index">
          {{ tag.name }}
        </el-tag>
      </div>

      <el-form inline :ref="'form' + index" v-for="(formListItem, index) in formList" :key="index"
        class="search-form search-form-new" v-show="showTagIndex == index" label-position="right" :model="formListItem"
        :rules="rules" label-width="100px">
        <el-form-item label="付款单据号:" prop="payableNo" class="input-with-col2 mr0">
          <el-input size="mini" disabled v-model.trim="formListItem.payableNo" placeholder="系统自动生成" clearable></el-input>
        </el-form-item>
        <el-form-item label="单据日期:" prop="billDate" class="input-with-col2 mr0">
          <el-date-picker v-model="formListItem.billDate" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
            unlink-panels clearable></el-date-picker>
        </el-form-item>
        <el-form-item label="付款金额:" prop="money" class="input-with-col2 mr0">
          <el-input size="mini" type="number" v-model.trim="formListItem.money" placeholder="请输入付款金额"
            clearable></el-input>
        </el-form-item>

        <el-form-item label="支付方式:" prop="card" class="input-with-col2 mr0">
          <el-select size="mini" v-model="formListItem.card" filterable placeholder="请选择支付方式" clearable value-key="id">
            <el-option v-for="item in cardList" :key="item.id" :label="item.cardCode + '--' + item.cardName"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="支出项:" prop="spending" class="input-with-col2 mr0">
          <el-select size="mini" v-model="formListItem.spending" filterable placeholder="请选择支出项" clearable
            @change="spendingChange" value-key="code">
            <el-option v-for="item in spendingList" :key="item.code" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="相关车辆:" prop="carInfo" class="input-with-col2 mr0" v-if="formListItem.showCar">
          <el-select size="mini" v-model="formListItem.carInfo" filterable placeholder="请选择支出项" clearable value-key="id">
            <el-option v-for="item in carList" :key="item.id" :label="item.car" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款人:" prop="user" class="input-with-col2 mr0" v-if="formListItem.showUser">
          <el-select size="mini" v-model="formListItem.user" filterable placeholder="请选择付款人" clearable value-key="userId">
            <el-option v-for="item in userList" :key="item.userId" :label="item.nickname" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户:" prop="propertyUnit" class="input-with-col2 mr0" v-if="formListItem.showProperty">
          <el-select size="mini" v-model="formListItem.propertyUnit" filterable placeholder="请选择客户" clearable
            value-key="id">
            <el-option v-for="item in propertyUnitSimpleList" :key="item.id" :label="item.unitName"
              :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称:" prop="content" class="input-with-col2 mr0" v-if="formListItem.showContent">
          <el-input size="mini" v-model.trim="formListItem.content" placeholder="请输入名称" clearable></el-input>
        </el-form-item>

        <el-form-item label="备注:" prop="remark" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="formListItem.remark" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { savePayable, savePayableList, userSimpleList } from "@/api/Payable";
import { getCardList } from "@/api/Card";
import { getCarList } from "@/api/Car";
import { getSpendingList } from "@/api/Spending";
import { getPropertyUnitSimpleList } from "@/api/Receive";
import cookies from "../../../libs/util.cookies";
export default {
  data() {
    return {
      spendingList: [],
      propertyUnitSimpleList: [],
      userList: [],
      cardList: [],
      carList: [],
      form: {
        spending: {},
        carInfo: {},
        card: {},
        user: {},
        billDate: "",
        money: "",
        remark: ""
      },
      formSelect: {
        spendingList: []
      },
      showTagIndex: 0,
      rulesSelect: {
        spendingList: [
          {
            validator: (rule, value, callback) => {
              // 验证是否选择了支出项，且不为空数组
              if (!value || value.length === 0) {
                callback(new Error("请选择支出项"));
              } else {
                callback(); // 验证通过
              }
            },
            type: "array",
            required: true,
            trigger: "change" // 在选择发生变化时触发验证
          }
        ]
      },
      tags: [],
      formList: [],
      rules: {
        billDate: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择日期"));
              } else {
                callback();
              }
            },
            required: true,
            trigger: "change"
          }
        ],
        // spending: [{
        //   required: true,
        //   message: "请选择支出项",
        //   trigger: "blur",
        // },],
        money: [
          {
            required: true,
            message: "请输入金额",
            trigger: "change"
          }
        ],
        user: [
          {
            validator: (rule, value, callback) => {
              if (!value || !value.userId) {
                callback(new Error("请选择付款人信息"));
              } else {
                callback();
              }
            },
            required: true,
            trigger: "change"
          }
        ],
        carInfo: [
          {
            validator: (rule, value, callback) => {
              if (!value || !value.id) {
                callback(new Error("请选择车辆信息"));
              } else {
                callback();
              }
            },
            required: true,
            trigger: "change"
          }
        ],
        card: [
          {
            validator: (rule, value, callback) => {
              if (!value || !value.id) {
                callback(new Error("请选择支付方式"));
              } else {
                callback();
              }
            },
            required: true,
            trigger: "change"
          }
        ]
      },
      showCar: false,
      showUser: false,
      showProperty: false,
      showContent: false,
      carCodeArr: ["0101", "0102", "0116", "0112"],
      userCodeArr: [
        "0101",
        "0102",
        "0104",
        "0105",
        "0106",
        "0107",
        "0110",
        "0111",
        "0112",
        "0113",
        "0114",
        "0115",
        "0116",
        "0117",
        "0118",
        "0119",
        "0120",
        "0121"
      ],
      propertyCodeArr: ["0113", "0114", "0121"],
      contentCodeArr: ["0102", "0106", "0107", "0111", "0113", "0114"],
      loadBtn: false
    };
  },
  created() {
    this.handleSpendingList();
    this.handleUserSimpleList();
    this.handleCarList();
    this.handleCardList();
    this.handlePropertyUnitSimpleList();
  },
  methods: {
    async handlePropertyUnitSimpleList() {
      const res = await getPropertyUnitSimpleList({});
      if (res.code === 200) {
        this.propertyUnitSimpleList = res.data;
      }
    },
    selectSpendingChange() {
      this.showTagIndex = 0;

      let newList = [];
      this.formSelect.spendingList.map((item, index) => {
        let flag = this.formList.some(items => {
          return items.name == item.name;
        });
        console.log(flag, "-======");
        if (!flag) {
          newList.push(this.returnNewListItem(item, index));
        } else {
          let aa = this.formList.find(items2 => {
            return items2.name == item.name;
          });
          console.log(aa, "???");
          newList.push(aa);
        }
      });
      this.formList = newList;

      this.tags = this.formSelect.spendingList.map(item => {
        return { name: item.name, type: "info" };
      });
      this.formSelect = { ...this.formSelect };
      console.log(this.formSelect, "formSelect");
      console.log(this.formList, "formList");
      console.log(this.tags, "tags");
    },
    returnNewListItem(item, index) {
      let obj = {
        spending: this.formSelect.spendingList[index],
        carInfo: {},
        card: {},
        user: {},
        billDate: "",
        money: "",
        remark: "",
        name: item.name,
        showCar: false,
        showUser: false,
        showProperty: false,
        showContent: false
      };
      this.showCar = false;
      this.showUser = false;
      if (this.carCodeArr.includes(item.code)) {
        obj.showCar = true;
      }
      if (this.userCodeArr.includes(item.code)) {
        obj.showUser = true;
      }
      if (this.propertyCodeArr.includes(item.code)) {
        obj.showProperty = true;
      }
      if (this.contentCodeArr.includes(item.code)) {
        obj.showContent = true;
      }
      return obj;
    },
    spendingChange(item) {
      this.showCar = false;
      this.showUser = false;
      if (this.carCodeArr.includes(item.code)) {
        this.showCar = true;
      }
      if (this.userCodeArr.includes(item.code)) {
        this.showUser = true;
      }
      if (this.propertyCodeArr.includes(item.code)) {
        this.showProperty = true;
      }
      if (this.contentCodeArr.includes(item.code)) {
        this.showContent = true;
      }
    },
    async handleCardList() {
      const res = await getCardList({});
      if (res.code === 200) {
        this.total = res.data.total;
        this.cardList = res.data;
      }
    },
    async handleCarList() {
      const res = await getCarList({});
      if (res.code === 200) {
        this.total = res.data.total;
        this.carList = res.data;
      }
    },
    async handleUserSimpleList() {
      const res = await userSimpleList({});
      if (res.code === 200) {
        this.total = res.data.total;
        this.userList = res.data;
      }
    },
    async handleSpendingList() {
      const res = await getSpendingList();
      if (res.code === 200) {
        this.total = res.data.total;
        this.spendingList = res.data;
      }
    },
    inArray(needle, array) {
      for (var i = 0; i < array.length; i++) {
        if (needle === array[i]) {
          return true;
        }
      }
      return false;
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    formatData(listData) {
      let arr = [];
      for (let i = 0; i < listData.length; i++) {
        const params = {
          ...listData[i]
        };
        console.log(params);
        params.type = params.spending.code;
        params.typeName = params.spending.name;
        params.cardId = params.card.id;
        params.cardCode = params.card.cardCode;
        if (this.carCodeArr.includes(params.type) && params.carInfo) {
          params.carId = params.carInfo.id;
          params.carCode = params.carInfo.car;
        } else {
          params.carId = null;
          params.carCode = null;
        }
        if (this.userCodeArr.includes(params.type) && params.user) {
          params.payUserId = params.user.userId;
          params.payUserName = params.user.nickname;
        } else {
          params.payUserId = null;
          params.payUserName = null;
        }
        if (this.propertyCodeArr.includes(params.type) && params.propertyUnit) {
          params.propertyUnitId = params.propertyUnit.id;
          params.propertyUnitName = params.propertyUnit.unitName;
        } else {
          params.propertyUnitId = null;
          params.propertyUnitName = null;
        }
        if (this.contentCodeArr.includes(params.type)) {
          params.content = params.content;
        } else {
          params.content = null;
        }
        delete params.carInfo;
        delete params.user;
        delete params.card;
        delete params.spending;
        console.log(params);
        arr.push(params);
      }
      return arr;
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      let flag = true;
      this.$refs.formRef.validate(async valid => {
        if (!valid) {
          flag = false;
        }
      });
      for (let i = 0; i < this.formList.length; i++) {
        const formRef = this.$refs["form" + i];
        formRef[0].validate(async valid => {
          if (!valid) {
            flag = false;
            return;
          }
        });
      }
      if (!flag) {
        this.$message({
          type: "warning",
          message: "存在未填写完整项，请填写"
        });
      } else {
        // 整理数据，调取新接口
        console.log(this.formList, "--hahaha--");
        let paramsList = this.formatData(this.formList);
        console.log(paramsList);
        const res = await savePayableList(paramsList);
        if (res.code === 200) {
          this.$message.success("添加成功");
          this.$emit("confirm");
        }
        this.loadBtn = false;
      }
    }
  }
};
</script>
<style>
.tag_box {
  padding: 10px 0;
}

.search-form-new {
  border: solid #ccc 1px;
  padding: 10px 5px 10px 30px;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Collect/components/AddCause.vue